import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { computed, watch } from "vue";
import { FilePanelProps } from "@/types";
import { integrationsStore } from "@/hooks";
import { SwitchInput, FlexBox, Typography } from "@/components/common";


/**
 * Displays any errors for this panel.
 */
const __default__ = {
  name: "UploadPanelErrors",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    panel: {},
    index: {},
    hideUploadType: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const errorMessage = computed(() => {
  if (
    (props.panel.variant === "artifact" || props.panel.variant === "trace") &&
    !props.panel.name
  ) {
    return "Requires a name";
  } else if (props.panel.ignoreErrors) {
    return undefined;
  } else if (
    (props.panel.variant === "artifact" || props.panel.variant === "trace") &&
    !props.panel.file &&
    !props.panel.isGenerated
  ) {
    return "No files have been uploaded.";
  } else if (
    (props.panel.variant === "jira" || props.panel.variant === "github") &&
    !integrationsStore.gitHubProject &&
    !integrationsStore.jiraProject
  ) {
    return "Select a project to import.";
  } else if (
    props.panel.variant === "bulk" &&
    (props.panel.bulkFiles.length === 0 ||
      !props.panel.bulkFiles.find(({ name }) => name === "tim.json")) &&
    !props.panel.emptyFiles
  ) {
    return "Requires a tim.json configuration file.";
  } else {
    return props.panel.parseErrorMessage;
  }
});

// Update the panel validity and error when the error check updates.
watch(
  () => errorMessage.value,
  (message) => {
    props.panel.errorMessage = message;
    props.panel.valid = !message;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(FlexBox), {
    "full-width": "",
    justify: "between",
    align: "center",
    y: "2"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(SwitchInput), {
        modelValue: props.panel.ignoreErrors,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((props.panel.ignoreErrors) = $event)),
        label: "Ignore Errors",
        color: "grey",
        class: "q-mr-sm",
        "data-cy": "button-ignore-errors"
      }, null, 8, ["modelValue"]),
      (!!errorMessage.value)
        ? (_openBlock(), _createBlock(_unref(Typography), {
            key: 0,
            value: errorMessage.value,
            color: "negative"
          }, null, 8, ["value"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})